// Figures taken from the 2023-2024 annual report; this is something that we'll likely want to update each year in parallel:
const defaultCards = {
  title: 'Last year, for every £1 that was donated to Comic Relief...',
  cardCopy: [
    {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '70p',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' was used to help tackle poverty and social injustice in the UK and internationally',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '2p',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ensured we allocated our funding as effectively as possible and monitored how it was spent',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '3p',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' helped raise awareness of the work we support to tackle poverty and injustice',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '25p',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' helped raise even more money!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  ]
};

export default defaultCards;
